<template>
  <a v-if="isExternal" v-bind="$attrs"
     :href="(to as string)">
    <slot />
  </a>
  <router-link v-else
               v-slot="{ isActive, href, navigate }"
               v-bind="$props"
               custom
  >
    <a @click="() => navigate"
       :href="href"
       v-bind="$attrs"
       :class="{ active: isActive }"
    >
      <slot />
    </a>
  </router-link>
</template>
<script setup lang="ts">
import { computed } from 'vue';
import { RouteLocationRaw, RouterLinkProps } from 'vue-router';

interface LinkProperties extends RouterLinkProps {
  to: RouteLocationRaw;
}

const props = defineProps<LinkProperties>();
const isExternal = computed(
  () => typeof props.to === 'string' && props.to.startsWith('http'),
);
</script>
